module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "catering"
  }, [_c('banner', {
    ref: "solutionBanner",
    attrs: {
      "clazz": "solution-banner",
      "url": _vm.currentId,
      "isSolution": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "catering-manage"
  }, [_c('div', {
    staticClass: "tc w1200"
  }, [_c('h1', {
    staticClass: "tc title"
  }, [_vm._v(_vm._s(_vm.cardsData.title))]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.cardsData.describe))]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix cards"
  }, _vm._l((_vm.cardsData.data), function(item) {
    return _c('li', [_c('h2', {
      staticClass: "cards-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "cards-desc"
    }, [_vm._v(_vm._s(item.describe))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tc catering-challenge"
  }, [_c('div', {
    staticClass: "w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.listData.title))]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.listData.describe))]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix challenge-list"
  }, _vm._l((_vm.listData.data), function(item) {
    return _c('li', {
      style: ({
        'width': 1200 / _vm.listData.data.length + 'px'
      })
    }, [_c('div', {
      staticClass: "challenge-li"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.img),
        expression: "item.img"
      }],
      attrs: {
        "alt": item.title
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "challenge-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "challenge-desc"
    }, [_vm._v(_vm._s(item.describe))])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "catering-layout"
  }, [_c('div', {
    staticClass: "w1200"
  }, [_c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.layoutData.title))]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.layoutData.describe))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "button-list tc"
  }, [_c('el-button', {
    staticClass: "video-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.openVideoPlayer
    }
  }, [_vm._v("查看视频")]), _vm._v(" "), _c('el-button', {
    staticClass: "whitebook-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.openPdf
    }
  }, [_vm._v("下载白皮书")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dib layout-bg"
  }, [_c('img', {
    attrs: {
      "src": _vm.layoutData.cover,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix layout-ul"
  }, _vm._l((_vm.layoutData.data), function(item) {
    return _c('li', [_c('div', {
      staticClass: "clearfix layout-w"
    }, [_c('div', {
      staticClass: "fl layout-w-left"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.img),
        expression: "item.img"
      }],
      attrs: {
        "alt": item.title
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "fl layout-w-right"
    }, [_c('h2', {
      staticClass: "layout-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "layout-desc"
    }, [_vm._v("\n                " + _vm._s(item.describe) + "\n              ")])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "catering-product"
  }, [_c('div', {
    staticClass: "tc w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.productData.title))]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("实现一个平台管理寻源、招投标到财务对账全流程采购管理")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix product-list"
  }, _vm._l((_vm.productData.data), function(item) {
    return _c('li', {
      style: ({
        'width': 1200 / _vm.productData.data.length + 'px'
      })
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.img ? _vm.$global.globalPath + item.img : ''),
        expression: "item.img ? $global.globalPath + item.img : ''"
      }],
      attrs: {
        "alt": "实现一个平台管理寻源"
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "product-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "product-btn"
    }, [_c('button', {
      attrs: {
        "round": ""
      },
      on: {
        "click": function($event) {
          return _vm.goRooter(item.url)
        }
      }
    }, [_vm._v("查看更多")])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "catering-purchase"
  }, [_c('div', {
    staticClass: "tc w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("他们采购管理已发生翻天覆地的变化")]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "purchase-carousel"
  }, [_c('el-carousel', {
    attrs: {
      "height": "266px",
      "indicator-position": "none"
    }
  }, _vm._l((_vm.exampleResult), function(item, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('div', {
      staticClass: "carousel-box clearfix"
    }, _vm._l((item), function(subItem) {
      return _c('div', {
        staticClass: "rel carousel-img"
      }, [_c('img', {
        attrs: {
          "src": _vm.$global.globalPath + subItem.jiej_img,
          "alt": "他们采购管理已发生翻天覆地的变化"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "abs carousel-w"
      }), _vm._v(" "), _c('div', {
        staticClass: "abs carousel-one"
      }), _vm._v(" "), _c('div', {
        staticClass: "abs carousel-box-desc"
      }, [_c('h2', {
        staticClass: "title abs"
      }, [_vm._v(_vm._s(subItem.title))]), _vm._v(" "), _c('div', {
        staticClass: "carousel-s"
      }, [_c('p', {
        staticClass: "desc"
      }, [_vm._v(_vm._s(subItem.jiej_describe))]), _vm._v(" "), _c('div', {
        staticClass: "look-detail"
      }, [_c('el-button', {
        attrs: {
          "round": ""
        },
        on: {
          "click": function($event) {
            return _vm.goClientDetail(subItem.id, subItem.status)
          }
        }
      }, [_vm._v("了解详情")])], 1)])])])
    }), 0)])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "catering-start-btn"
  }, [_c('button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goMoreCase
    }
  }, [_vm._v("更多案例")])])])]), _vm._v(" "), _c('div', {
    staticClass: "catering-start"
  }, [_c('div', {
    staticClass: "tc w1200"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("现在就开始")]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "catering-tips"
  }, [_vm._v("咨询热线：400-116-0808")]), _vm._v(" "), _c('div', {
    staticClass: "catering-start-btn"
  }, [_c('button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister(("jiejuefangan-" + (_vm.currentSolution.code) + "-yanshi"))
      }
    }
  }, [_vm._v("申请演示")])])])]), _vm._v(" "), _c('div', {
    staticClass: "catering-video"
  }, [_c('el-dialog', {
    attrs: {
      "custom-class": "customClass",
      "visible": _vm.centerDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      },
      "close": _vm.closeVideoDialog
    }
  }, [_c('div', {
    staticClass: "video-test"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVideoImg),
      expression: "showVideoImg"
    }],
    staticClass: "video-img tc cp",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoPlay.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "video-title dib"
  }, [_vm._v(_vm._s(_vm.videoText))])]), _vm._v(" "), _c('div', {
    staticClass: "homeDialog-video",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.videoClick.apply(null, arguments)
      }
    }
  }, [_c('video', {
    attrs: {
      "src": _vm.videoLink,
      "id": "homeVideo",
      "preload": "auto",
      "controls": "controls",
      "autoplay": ""
    },
    on: {
      "seeked": _vm.videoSeek,
      "pause": _vm.videoClick,
      "error": _vm.videoError,
      "ended": _vm.videoDown
    }
  })])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desc"
  }, [_c('p', [_vm._v("每个业务都有自己独特的挑战和机遇。所以甄云随需而变")]), _vm._v(" "), _c('p', [_vm._v("创造独特的解决方案，适合您的行业帮助您应用采购技术，实现采购管理变革！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29d2fb8e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solution/solution.vue
// module id = 680
// module chunks = 12